import * as actionTypes from '../constants/userActionTypes';
import * as api from '../api';
import { toast } from "react-toastify";

/**
* function for get user
* @param {*} data User id 
* @description get user by id
* @param {function} getPartners getPartners function
*/
export const getPartners = () => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_PARTNER_REQUEST })
        const { data } = await api.getAllPartner()
        dispatch({ type: actionTypes.GET_PARTNER_SUCCESS, payload: data })

    } catch (err) {
        console.log(err)
        dispatch({ type: actionTypes.GET_PARTNER_FAIL, payload: err.response.data.message })
    }
}
/**
* function for get user
* @param {*} data User id 
* @description get user by id
* @param {function} getPartners getPartners function
*/
export const getPartnersOptions = () => async dispatch => {
    try {
        dispatch({ type: actionTypes.LOAD_PARTNER_REQUEST })
        const { data } = await api.getAllPartnerOption()
        dispatch({ type: actionTypes.LOAD_PARTNER_SUCCESS, payload: data })

    } catch (err) {
        console.log(err)
        dispatch({ type: actionTypes.LOAD_PARTNER_FAIL, payload: err.response.data.message })
    }
}

/**
* function for user partnerCreate
* @param {*} data form data and history
* @description user partnerCreate
* @param {function} partnerCreate partnerCreate function
*/
export const partnerCreate = (formData, history) => async dispatch => {
    try {
        dispatch({ type: actionTypes.CREATE_PARTNER_REQUEST })
        const { data } = await api.storePartner(formData);
        toast.success(data.message);
        dispatch({ type: actionTypes.CREATE_PARTNER_SUCCESS, payload: data })
        history.push('/login')

    } catch (err) {
        console.log('error is: ', err.response.data)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.CREATE_PARTNER_FAIL, payload: err.response.data.message })
    }
}




export const destroyPartner = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.DELETE_PARTNER_REQUEST })
        const { data } = await api.deletePartner(formData)
        dispatch({ type: actionTypes.DELETE_PARTNER_SUCCESS, payload: formData })
        toast.success(data.message);
    } catch (err) {
        console.log(err)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.DELETE_PARTNER_FAIL, payload: err.response.data.message })
    }
}

export const addNewPartner = (partners) => async dispatch =>{
    try {
        dispatch({ type: actionTypes.CREATE_PARTNER_REQUEST })
        const { data } = await api.addNewParnter(partners);
        toast.success(data.message);
        dispatch({ type: actionTypes.CREATE_PARTNER_SUCCESS, payload: data })
    } catch (err) {
        console.log('error is: ', err.response.data)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.CREATE_PARTNER_FAIL, payload: err.response.data.message })
    }
}

export const checkInvitationEmail = (email, projectId) => async dispatch =>{
    try {
        dispatch({ type: actionTypes.CHECK_INVITATION_EMAIL_REQUEST })
        const { data } = await api.checkInvitationEmail(email, projectId);
        dispatch({ type: actionTypes.CHECK_INVITATION_EMAIL_SUCCESS, payload: data })
    } catch (err) {
        console.log('error is: ', err.response.data)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.CHECK_INVITATION_EMAIL_FAIL, payload: err.response.data.message })
    }
}
/**
* function for project Audience Type
* @param {*} data Audience Type data 
* @description get Audience Type infromation
* @param {function} AudienceType Audience Type function
*/
export const acceptInvitation = (formData, history) => async dispatch => {
    try {
        
        const { data } = await api.acceptInvitationProject(formData);
        toast.success(data.message);
        history.push('/');
    } catch (err) {
        toast.error(err.response.data.message);
        history.push('/');
    }
}